// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__9t2jG","name":"ConsentHeader_name__dFM3V","birthday":"ConsentHeader_birthday__1-SgT","skeleton":"ConsentHeader_skeleton__3DQDL"};